import { DiTokens } from "services/diTokens";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";

@Module({
  name: "settings",
  namespaced: true
})
export class SettingsStore extends VuexModule {}
